export const Marquee = ({ items = [], variant = "black", speed = "normal" }) => {
  const bg =
    variant === "black"
      ? "bg-black text-white"
      : variant === "red"
        ? "text-white"
        : variant === "green"
          ? "text-black"
          : "bg-white text-black";
  const style =
    variant === "red"
      ? { background: "#0057FF" }
      : variant === "green"
        ? { background: "#8CB037" }
        : {};
  const speedClass = speed === "fast" ? "marquee-track-fast" : "marquee-track";

  return (
    <div
      data-testid={`marquee-${variant}`}
      className={`relative overflow-hidden border-y-[3px] border-black ${bg} py-3`}
      style={style}
    >
      <div className={`flex whitespace-nowrap ${speedClass}`}>
        {[...items, ...items, ...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-luckiest text-2xl sm:text-3xl px-6 flex items-center gap-6"
          >
            {t}
            <span
              className="inline-block w-3 h-3 rounded-full"
              style={{
                background:
                  variant === "green"
                    ? "#000"
                    : variant === "red"
                      ? "#FFD500"
                      : "#0057FF",
              }}
            />
          </span>
        ))}
      </div>
    </div>
  );
};
